import subscriptionsCampaignTdsChange from './actions/campaignTdsChange';
import subscriptionsCampaignTdsCreate from './actions/campaignTdsCreate';
import subscriptionsCampaignTdsDetail from './actions/campaignTdsDetail';
import subscriptionsCampaignTdsList from './actions/campaignTdsList';
import subscriptionsCampaignTdsRemove from './actions/campaignTdsRemove';
import subscriptionsGetCampaignTdsList from './getters/getCampaignTdsList';
import subscriptionsCampaignTdsUpload from './mutations/campaignTdsUpload';

const actions = {
    subscriptionsCampaignTdsChange,
    subscriptionsCampaignTdsCreate,
    subscriptionsCampaignTdsDetail,
    subscriptionsCampaignTdsList,
    subscriptionsCampaignTdsRemove
};

const mutations = {
    subscriptionsCampaignTdsUpload
};

const getters = {
    subscriptionsGetCampaignTdsList
};

export default { actions, mutations, getters };
